import { RouteConfig } from 'vue-router';

import BenefitUsageHistory from '@/components/BenefitUsageHistory.vue';
import store from '@/store/store';
import { baseFilters } from '@/utils/baseFilters';

export const benefitUseListRoute: RouteConfig = {
  path: 'benefitUsages',
  name: 'benefitUsages',
  component: BenefitUsageHistory,
  props: { global: true },
  beforeEnter: (to, _from, next) => {
    const filters = { ...baseFilters(to) } as any;

    if (to.query.partnerId) {
      filters.partnerId = +to.query.partnerId;
    }
    if (to.query.benefitId) {
      filters.benefitId = +to.query.benefitId;
    }
    if (to.query.dateStart) {
      filters.dateStart = new Date(to.query.dateStart as string);
    }
    if (to.query.dateEnd) {
      filters.dateEnd = new Date(to.query.dateEnd as string);
    }
    const promises = [store.dispatch('benefitsHistory/list', filters), store.dispatch('access/check', ['PROFILE.GET'])];

    if (to.query.partnerId) {
      promises.push(store.dispatch('partners/get', filters.partnerId));
    }
    if (to.query.benefitId) {
      promises.push(store.dispatch('benefit/get', filters.benefitId));
    }
    Promise.all(promises)
      .then(() => {
        store.commit('breadcrumbs/set', [{ text: 'Wykorzystanie usług', disabled: true }]);
        next();
      })
      .catch(() => store.dispatch('notifyError', { title: 'Nie udało się pobrać listy wykorzystanych usług.' }));
  },
  meta: { toolbarTitle: 'Wykorzystanie usług' }
};
